import { Button, Form } from "antd";
import ConfirmPopup from "../../../commons/components/ConfirmPopup/ConfirmPopup";
import FormHeader from "../../../commons/components/FormHeader/FormHeader";
import GradientText from "../../../commons/components/GradientText/GradientText";
import PrimaryButton from "../../../commons/components/PrimaryButton/PrimaryButton";
import styles from "../../../components/AccountInformation/AccountInformation.module.scss";
import AcountInformation from "./AccountInformation";
import useUpdateAccountInformation from "./Hooks/useUpdateAccountInformation";
import MerchantInformation from "./MerchantInformation";
import PaymentDetail from "./PaymentDetail";

const UpdateAccountInformation = () => {
  const {
    handleCancel,
    handleTrackFieldsTouched,
    phonePattern,
    loading,
    form,
    statusUpdate,
    data,
    openConfirmPopup,
    handleOpenModal,
    setData,
    submitChange,
    handleCancelModal,
  } = useUpdateAccountInformation();

  return (
    <div className={styles.wrapper}>
      <Form form={form} name="basic" onFinish={handleOpenModal} autoComplete="off">
        <FormHeader
          title={"Update Information"}
          actions={
            <>
              <Button type="text" className={styles.cancel} onClick={handleCancel} disabled={loading}>
                Cancel
              </Button>
              <Form.Item noStyle shouldUpdate={() => true}>
                {() => {
                  return (
                    <PrimaryButton
                      onClick={() => form.submit()}
                      className={styles.save}
                      disabled={
                        loading ||
                        !!form.getFieldsError().find(item => item.errors.length) ||
                        statusUpdate === "PENDING"
                      }
                    >
                      {loading ? "Saving" : "Update"}
                    </PrimaryButton>
                  );
                }}
              </Form.Item>
            </>
          }
        />

        <div className={styles.panel}>
          <div className={styles.noteForUpdate}>
            {statusUpdate === "PENDING" ? (
              <GradientText text=" This is your current update form. Please wait still admin approve your data change" />
            ) : (
              <GradientText
                text="  Your changes will not be applied until they have been approved by an administrator. Please make sure to
          proofread your information carefully before submitting it."
              />
            )}
          </div>
          <AcountInformation
            form={form}
            phonePattern={phonePattern}
            handleTrackFieldsTouched={handleTrackFieldsTouched}
          />

          <MerchantInformation
            form={form}
            data={data}
            setData={setData}
            handleTrackFieldsTouched={handleTrackFieldsTouched}
          />

          <PaymentDetail form={form} handleTrackFieldsTouched={handleTrackFieldsTouched} />
        </div>
      </Form>

      <ConfirmPopup
        open={openConfirmPopup}
        onCancel={handleCancelModal}
        title="Update Information"
        description={`Are you sure want to update your information? We will notify you once your account has been approved.`}
        onConfirm={() => {
          submitChange(form.getFieldsValue());
        }}
      />
    </div>
  );
};

export default UpdateAccountInformation;
